import { render, staticRenderFns } from "./IconsPages.vue?vue&type=template&id=1ce90764&scoped=true&"
import script from "./IconsPages.vue?vue&type=script&lang=js&"
export * from "./IconsPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce90764",
  null
  
)

export default component.exports